import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Dashboard } from './pages/Dashboard';
import { TimeEntryPage } from './pages/TimeEntryPage';
import { ClientsPage } from './pages/ClientsPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ReportsPage } from './pages/ReportsPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { SearchPage } from './pages/SearchPage';
import { TasksPage } from './pages/TasksPage';
import { AdhocQueryPage } from './pages/AdhocQueryPage';
import { MainLayout } from './components/layout/MainLayout';
import { useThemeStore } from './store/themeStore';

function ThemeManager() {
  const theme = useThemeStore((state) => state.theme);
  const location = useLocation();

  React.useEffect(() => {
    const isLandingPage = location.pathname === '/' || location.pathname === '/login';

    if (isLandingPage) {
      document.documentElement.classList.remove('dark');
    } else if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme, location.pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeManager />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LandingPage />} />

        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/time-entry" element={<TimeEntryPage />} />
          <Route path="/expenses" element={<ExpensesPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/ask" element={<AdhocQueryPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
